
import { supabase } from '@/integrations/supabase/client';

export interface LocationSuggestion {
  place_id: string;
  description: string;
  main_text?: string;
  secondary_text?: string;
  structured_formatting?: {
    main_text: string;
    secondary_text: string;
  };
}

export const getLocationSuggestions = async (input: string): Promise<LocationSuggestion[]> => {
  if (!input || input.trim().length < 2) {
    return [];
  }

  try {
    const { data, error } = await supabase.functions.invoke('places-autocomplete', {
      body: { input },
    });

    if (error) {
      console.error('Error fetching location suggestions:', error);
      throw error;
    }

    if (!data.predictions) {
      return [];
    }

    // Transform Google's response to our LocationSuggestion format
    return data.predictions.map((prediction: any) => ({
      place_id: prediction.place_id,
      description: prediction.description,
      main_text: prediction.structured_formatting?.main_text,
      secondary_text: prediction.structured_formatting?.secondary_text,
      structured_formatting: prediction.structured_formatting
    }));
  } catch (error) {
    console.error('Error getting location suggestions:', error);
    return [];
  }
};
